// APIで通信を行わずに、mockを使用する
export const API_USE_MOCK = false
// 1ページに表示する最大数
export const VIEW_MAX_LIST_NUMBER = 5
